export default __webpack_public_path__ + "static/media/plumeria.88d52c25.jpg";